import { atom } from 'recoil'

export const isOpenMenuServersUrlState = atom({
  key: 'isOpenMenuServersUrlState',
  default: false
})
